import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Group } from 'src/app/shared/interfaces/group.interface';
import { environment } from 'src/environments/environment';
import { GroupService } from '../group.service';

@Component({
  selector: 'app-group-view',
  templateUrl: './group-view.component.html',
  styleUrls: ['./group-view.component.css'],
})
export class GroupViewComponent implements OnInit {
  group: Group;
  items = Array.from({ length: 100000 }).map((_, i) => `Item #${i}`);
  constructor(
    private activeRouter: ActivatedRoute,
    private groupService: GroupService,
    private toastr: ToastrService
  ) {
    this.activeRouter.params.subscribe((params) => {
      if (params.id) {
        this.getGroup(params.id);
      }
    });
  }

  ngOnInit(): void {}

  getGroup(id: number) {
    return this.groupService
      .getById(id)
      .then((res) => {
        this.group = res;
      })
      .catch((err) => {
        this.toastr.error(err.error.message || 'Algo de errado aconteceu!');
      });
  }

  getAvatar(memberAvatar: any): any {
    if (!memberAvatar) {
      return '../../../assets/icons/default-user-icon-profile.png';
    } else {
      return environment.endPointApi + 'user/avatar/' + memberAvatar.file_name;
    }
  }
}
